var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconWrapper } from ".";
export const AvatarPlaceholderIcon = React.forwardRef((_a, ref) => {
    var { color = "primary" } = _a, otherProps = __rest(_a, ["color"]);
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 24, height: 24, color: color }, otherProps),
        React.createElement("g", { "clip-path": "url(#clip0)" },
            React.createElement("circle", { cx: "48", cy: "48", r: "48", fill: "white" }),
            React.createElement("path", { d: "M48.0006 0C21.5339 0 0 21.5339 0 48.0006C0 74.4684 21.5339 96 48.0006 96C74.4672 96 96.0011 74.4684 96.0011 47.9994C96.0011 21.5328 74.4672 0 48.0006 0ZM48.0543 16.9215C61.6995 16.9215 72.7604 27.9813 72.7604 41.6264C72.7604 55.2716 61.6995 66.3325 48.0543 66.3325C34.4103 66.3325 23.3494 55.2727 23.3494 41.6264C23.3494 27.9824 34.4103 16.9215 48.0543 16.9215ZM48.0006 89.8501C36.1743 89.8501 25.4851 84.9127 17.8687 76.9977C21.3234 72.3337 25.905 68.4946 31.2473 65.8749C36.0233 69.1924 41.8117 71.144 48.0532 71.144C54.2935 71.144 60.0831 69.1924 64.858 65.8749C70.1808 68.4809 74.7441 72.2983 78.1943 76.9325C70.572 84.8853 59.8589 89.8501 48.0006 89.8501Z", fill: "#C4CBD4" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0" },
                React.createElement("rect", { width: "96", height: "96", fill: "white" })))));
});
//# sourceMappingURL=AvatarPlaceholder.js.map